import React, { Fragment } from 'react'
import { EXPLANATION_CONTENT } from './EXP_CONTENT'
import { Description } from './ExpStyled'
import ExplanationTable from './ExpTable'
import { DESCRIPTION_PROPS } from './interface'

export default function Explanation({ colors }: DESCRIPTION_PROPS) {
  return (
    <Fragment>
      {EXPLANATION_CONTENT.map((item: any, id: any) => (
        <Description key={id} colors={colors}>
          {id === 0 ? <h3>{item.Title}</h3> : <h4>{item.Title}</h4>}
          <p>{item.Description}</p>
        </Description>
      ))}
      <ExplanationTable colors={colors} />
    </Fragment>
  )
}
